export type LodGenerationOptions = {
	/** Point ratios relative to the original model, for LOD1 onward. LOD0 stays unchanged. */
	levelRatios?: readonly number[];
};

export const MAX_LOD_REDUCED_LEVELS = 7;
export const DEFAULT_LOD_LEVEL_RATIOS: readonly number[] = [0.5, 0.25, 0.125];
export const LOD_LEVEL_POINT_COUNT_ERROR =
	"元モデルの点数では、この段階数を作成できません。段階を減らすか、点数の割合を下げてください。";

export function validateLodGenerationOptions(options?: LodGenerationOptions): string | null {
	if (options?.levelRatios === undefined) return null;
	const ratios = options.levelRatios;
	if (!Array.isArray(ratios) || ratios.length < 1 || ratios.length > MAX_LOD_REDUCED_LEVELS)
		return `LOD1以降は1〜${MAX_LOD_REDUCED_LEVELS}段階で設定してください。`;
	let previous = 1;
	for (let index = 0; index < ratios.length; index++) {
		const ratio = ratios[index];
		if (!Number.isFinite(ratio) || ratio <= 0 || ratio >= 1)
			return "点数の割合は0%より大きく、100%より小さい値にしてください。";
		if (ratio >= previous) return "LODの点数は、前の段階より少なくしてください。";
		previous = ratio;
	}
	return null;
}

/** Resolves original-relative ratios after the cleaned source point count is known. */
export function resolveLodTargetCounts(originalCount: number, options?: LodGenerationOptions): number[] {
	const error = validateLodGenerationOptions(options);
	if (error) throw new Error(error);
	if (!Number.isSafeInteger(originalCount) || originalCount < 2)
		throw new Error("このモデルにはLODを作成するための点が足りません。");
	if (options?.levelRatios === undefined) {
		// Preserve the existing adaptive levels and rounding for automatic mode.
		const levelCount = Math.min(8, Math.max(4, Math.ceil(Math.log2(originalCount / 50000)) + 1));
		return Array.from({ length: levelCount }, (_, level) => Math.max(1, Math.floor(originalCount / 2 ** level)));
	}
	const counts = [originalCount];
	for (const ratio of options.levelRatios) {
		const target = Math.max(1, Math.floor(originalCount * ratio));
		if (target >= counts[counts.length - 1]) throw new Error(LOD_LEVEL_POINT_COUNT_ERROR);
		counts.push(target);
	}
	return counts;
}
